import { getUniqueId } from 'helpers'

interface Widget {
    type: string
    settings?: Array<{
        key: string
        value: string
        links: any[]
        richDescription: string
        attachmentId: string
        attachment: any
    }>
    widgetGuid?: string
    [key: string]: any
}

interface Column {
    width: number[]
    widgets: Widget[]
    [key: string]: any
}

interface Row {
    isFullWidth: boolean
    backgroundColor: string
    columns: Column[]
    rowGuid?: string
    [key: string]: any
}

// To be able to be dragged, rows and widgets need a unique guid that doesn't change when the row changes position
export function addUniqueGuids(rows: Row[]): Row[] {
    return rows.map((row) => ({
        ...row,
        rowGuid: getUniqueId('row'),
        columns: row.columns.map((column) => ({
            ...column,
            widgets: column.widgets.map((widget) => ({
                ...widget,
                widgetGuid: getUniqueId('widget'),
            })),
        })),
    }))
}

// But we don't want to send the unique guids to the server
export function removeUniqueGuids(rows: Row[]): Row[] {
    return rows.map((row) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { rowGuid, ...rest } = row
        return {
            ...rest,
            columns: row.columns.map((column) => {
                return {
                    ...column,
                    widgets: column.widgets.map((widget) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const { widgetGuid, ...rest } = widget
                        return rest
                    }),
                }
            }),
        }
    })
}
